<template>
  <div class="gameplan">
    <ContentHeader path-set-type="append" :gameplan-nav="true" />
    <div class="content-wrapper" v-loading="loading">
      <el-row>
        <el-col :span="6" class="content-left">
          <div class="menu-container">
            <el-card class="nav-panel nav-panel-sp" v-if="employeeLevel>=45">
              <div slot="header" class="clearfix">
                <span class="panel-header">活动主题状态</span>
              </div>
              <el-menu @select="clickMenu" :default-active="themeDetailStatus" active-text-color="#101010" text-color="#101010">
                <el-menu-item index="01">
                  <span slot="title">待配置</span>
                </el-menu-item>
                <el-menu-item index="02">
                  <span slot="title">执行中</span>
                </el-menu-item>
                <el-menu-item index="03">
                  <span slot="title">已完成</span>
                </el-menu-item>
              </el-menu>
            </el-card>
          </div>
        </el-col>
        <el-col :span="18" class="content-right">
          <div class="search">
            <el-form :inline="true" :model="queryParams" ref="searchForm" class="searchForm">
              <el-form-item class="item" prop="prNumber">
                <el-input v-model="queryParams.prNumber" placeholder="PR编码" size="small" clearable/>
              </el-form-item>
              <el-form-item class="item" prop="prName">
                <el-input v-model="queryParams.prName" placeholder="PR名称" size="small" clearable/>
              </el-form-item>
              <el-form-item class="item" prop="themeName">
                <el-input v-model="queryParams.themeName" placeholder="活动名称"  size="small" clearable/>
              </el-form-item>
              <el-form-item class="item" prop="brandCode">
                <el-select v-model="queryParams.brandCode" placeholder="选择品牌" size="small" clearable>
                  <el-option v-for="item in btmpBrandDTOList" :key="item.brandCode" :label="item.brandDisplayName" :value="item.brandCode">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="item" prop="themeChannelScope">
                <el-select v-model="queryParams.themeChannelScope" placeholder="选择渠道" size="small" clearable>
                  <el-option v-for="item in gpThemeChannelMap" :key="item.key" :label="item.value" :value="item.key">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="item-btn">
                <el-button type="danger" size="small" @click="getGameplanThemeList()">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="info" size="small" @click="resetForm()">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="add-theme-btn">
            <el-button type="danger" size="small" @click="addThemeInfo">新建活动主题</el-button>
          </div>
          <div v-if="themeList.length>0">
            <div class="pr-box  is_hover_shadow" v-for="item of themeList" :key="item.themeId">
                <div class="space-between">
                  <div class="pr-title"> {{item.themeName}} <span class="pr-level">{{ getOrgLevel(item.orgLevel) }}</span> </div>
                  <div class="pr-status"> {{getThemeStatus(themeDetailStatus)}} </div>
                </div>
                <div class="pr-item-flex">
                  <div style="margin-top:12px;"><span class="font-weight-bold">PR信息：</span>{{getItemInfo(item.gpPrDTOList,'pr')}}</div>
                </div>
                <div class="pr-item-flex">
                  <div style="margin:12px 0;"><span class="font-weight-bold">品牌信息：</span>{{ getItemInfo(item.gpPrDTOList,'brand') }}</div>
                </div>
                <!-- <div class="pr-item">
                  <div>
                    PR信息：{{getItemInfo(item.gpPrDTOList,'pr')}}
                    &ensp;&ensp;&ensp;

                  </div>
                </div>
                <div  class="pr-item">
                  品牌信息：{{ getItemInfo(item.gpPrDTOList,'brand') }}
                </div> -->
                <div class="pr-item">
                  <div> <span class="font-weight-bold">活动时间：</span> {{ item.themeStartTime | parseTime("{y}-{m}-{d}") }} {{item.themeStartTime?'-':''}}  {{ item.themeEndTime | parseTime("{y}-{m}-{d}") }} </div>
                </div>
                <div class="pr-item space-between">
                  <div> <span class="font-weight-bold">已配置活动：</span>{{ item.totalQty |toThousandslsFilter()}} &ensp; <span class="font-weight-bold">已提报场次：</span>{{ item.submitQty |toThousandslsFilter()}}</div>
                  <div class="operation_btn_box">
                    <div class="operate_btn operate_btn_white" v-if="!item.submit&&isOwner(item.themeOwnerCode)&&themeDetailStatus==='01'" @click="deleteThemeInfo(item.themeId)">删除活动主题</div>
                    <div class="operate_btn operate_btn_white" v-if="!item.submit&&isOwner(item.themeOwnerCode)&&themeDetailStatus==='01'" @click="handleShowHistoryDialog(item.themeId)">从历史复制</div>
                    <div class="operate_btn operate_btn_white" v-if="themeDetailStatus!=='03'&&item.submit&&isOwner(item.themeOwnerCode)" @click="gotoWeb('PO-connect',item.themeId)">关联供应商</div>
                    <div class="operate_btn operate_btn_white" v-if="!(themeDetailStatus==='01'&&!item.submit)" @click="gotoWeb('activity-theme-info',item.themeId)">查看详情</div>
                    <div class="operate_btn operate_btn_red" v-if="themeDetailStatus!=='03'&&!(isRegion&&!isOwner(item.themeOwnerCode))" @click="gotoWeb('configure-theme-detail',item.themeId,item.themeOwnerCode)">继续配置</div>
                  </div>
                </div>
            </div>
            <div class="pagination">
              <el-pagination background :total="total" layout="total, prev, pager, next" :current-page="queryParams.page"
                :page-size="queryParams.pageSize" @current-change="handleCurrentChange" @size-change="handleSizeChange" />
            </div>
          </div>
          <div v-else class="margin_bottom_20 no-data">暂无数据</div>
        </el-col>
      </el-row>
    </div>

    <ConfigureItemHistoryDialog ref="historyDialogRef"/>

  </div>
</template>
<script>
import { mapGetters,mapState } from 'vuex'
import gameplanApi from "@/api/gameplan";
import ContentHeader from '@/components/content-header'
import ConfigureItemHistoryDialog from "./components/configure-item-history-dialog.vue"
export default {
  name: 'activity-management-list',
  components: {
    ContentHeader,
    ConfigureItemHistoryDialog
  },
  data() {
    return {
      themeDetailStatus:'01',
      themeList:[],
      total: 0,
      queryParams: {
        page: 1,
        pageSize: 10,
        queryCondition:'01',
        prNumber: '', // PR编码
        prName:'', // PR名称
        themeName: '', // 活动名称
        brandCode: '', // 选择品牌
        themeChannelScope: '', // 选择渠道
      },
      btmpBrandDTOList:[],
      themeLit:[
        {}
      ],
      employeeLevel:'',
      loading:false,
      prList:[],
      themeChannelMap:[],
      themeChannelCode:'01'
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    ...mapState({
      gpThemeChannelMap:state=> state.base.gpThemeChannelMap,
    }),
    isHQ(){
      return this.employeeLevel>=90
    },
    isBU(){
      return this.employeeLevel>=60&&this.employeeLevel<90
    },
    isRegion(){
      return this.employeeLevel>=45&&this.employeeLevel<60
    },
  },
  created() {
    this.$store.dispatch('getDictByName','gpThemeChannelMap')
    this.employeeLevel = this.userInfo.employeeLevel
    this.getGameplanThemeList()
    this.getGamepalnBrandquery()
  },
  methods: {
    getOrgLevel(orgLevel){
      if(orgLevel&&orgLevel.length===2) return orgLevel.toUpperCase()
      else return 'Region'
    },
    getItemInfo(gpPrDTOList,type){
      let brandInfo = []
      let prInfo = []
      if(gpPrDTOList){
        gpPrDTOList.forEach(item=>{
          let data = ''
          if(type==='pr') prInfo.push(item.prNumber+'-'+item.prName)
          else {
            if(item.brandName&&item.subBrandName)  data = item.brandName+'-'+item.subBrandName
            else data = item.brandName||item.subBrandName
            if(brandInfo.indexOf(data)===-1) {
              brandInfo.push(data)
            }
          }
        })
      }
      if(type==='pr') return prInfo.join('、')
      else return brandInfo.join('、')
    },
    async getGamepalnBrandquery() {
      const { data } = await gameplanApi.getGamepalnBrandquery();
      if (data.resultCode === "0") {
        this.btmpBrandDTOList = data.resultData?.btmpBrandDTOList || [];
      }
    },
    deleteThemeInfo(themeId){
      this.$confirm('是否确定删除该活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'btn-red',
        type: 'warning'
      }).then(async() => {
        const params = { themeId }
        const { data } = await gameplanApi.getGameplanThemeDeleteThemeInfo(params);
        if (data.resultCode === "0") {
          this.$alert('删除成功', '提示', {
            confirmButtonText: '确定',
            confirmButtonClass: 'btn-red',
          });
          this.getGameplanThemeList()
        }
      }).catch(() => {
      });
    },
    toConfigure(themeStatus){
      if(this.employeeLevel>=90){
        return themeStatus==0
      }else if(this.employeeLevel>=60&&this.employeeLevel<=90){
        return themeStatus==100 || themeStatus==0
      }else if(this.employeeLevel>=45&&this.employeeLevel<=60){
        return themeStatus==0
      }
      return true
    },
    isOwner(themeOwnerCode){
      return this.userInfo.employeeCode===themeOwnerCode
    },
    clickMenu(index) {
      this.themeDetailStatus = index;
      this.queryParams.queryCondition = index
      this.queryParams.page = 1;
      this.getGameplanThemeList();
    },
    addThemeInfo(){
      this.$router.push({ name:'configure-theme-info' })
    },
    gotoWeb(name,themeId,themeOwnerCode){
      this.$router.push({ name ,query:{themeId}})
    },
    async getGameplanThemeList(page,pageSize) {
      this.loading = true
      const { data } = await gameplanApi.getGameplanThemeThemeList(this.queryParams);
      if (data.resultCode === "0") {
        this.themeList = data.resultData?.themeList || [];
        this.prList = []
        this.total = data.resultData.pageInfo.totalCounts
      }
      this.loading = false
    },
    getThemeStatus(themeStatus){
      switch (themeStatus) {
        case '01':
          return '待配置'
        case '02':
          return '执行中'
        case '03':
          return '已完成'
        default:
          break;
      }
      return 0
    },
    getThemeChannels(themeChannels){
      let result = ''
      for(let item of themeChannels){
        result+=item.themeChannelEnName + '、'
      }
      return result.substr(0, result.length - 1);
    },
    handleCurrentChange(val) {
      this.queryParams.page = val
      this.getGameplanThemeList()
    },
    handleSizeChange (val) {
      this.queryParams.pageSize = val
      this.getGameplanThemeList()
    },
    resetForm() {
      this.$refs.searchForm.resetFields();
      this.queryParams.page=1
      this.queryParams.pageSize=10
      this.getGameplanThemeList()
    },
    handleShowHistoryDialog(themeId){
      this.$refs.historyDialogRef.handleShow(themeId)
    }
  }
}
</script>
<style lang="scss" scoped>
.is-hover-shadow:hover {
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
}

.margin-top-20{
  margin-top: 30px !important;
}
.nav-panel {
  width: 80%;
  margin: 0 auto;
  background: $base-white;

  //   .el-menu-item:last-child{
  //     border-bottom: 0;
  //   }
  ::v-deep .el-card__header {
    height: 70px;
    line-height: 35px;
  }
  ::v-deep .el-card__body {
    padding: 0;
  }
  .panel-header {
    font-size: 16px;
    font-weight: 700;
    color: #CD1231;
  }

  ::v-deep .el-menu {
    border-right: 0;
  }
  ::v-deep .el-menu-item {
    border-bottom: 1px solid $base-grey5;
  }
  ::v-deep .el-menu-item.is-active {
    color: $base-red;
  }
}

.add-theme-btn{
  width: 100%;
  display: flex;
  justify-content: right;
  margin: -15px 0 15px 0;
}
.pr-box{
  margin-bottom: 15px;
  padding: 15px 10px 5px 10px;
  background-color: #ffffff;
  border-radius: 8px;
  .pr-item{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 12px;
  }
  .space-between{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .pr-title{
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
    width: 800px;
    word-wrap: break-word;
  }
  .pr-level{
    color: white;
    //display: inline-block;
    font-size: 14px;
    line-height: 24px;
    padding: 0 10px;
    background-color: rgb(71, 172, 255);
  }
  .pr-status {
    color: rgb(192, 1, 1);
    font-size: 16px;
    font-weight: 600;
  }
  .operation_btn_box{
    display: flex;
    .operate_btn{
      text-align: center;
      padding: 5px 12px;
      border-radius: 4px;
      margin: -5px 0  0 10px;
      cursor: pointer;
    }
    .operate_btn_red {
      color: white;
      background-color: rgb(214, 0, 0);
    }
    .operate_btn_white{
      color: rgb(214, 0, 0);
      background-color: white;
      border: 1px solid rgb(214, 0, 0);
    }
  }
}
.menu-container{
  margin-top: -20px;
}
.content-wrapper {
  min-height: calc(100vh - 320px) !important;
  font-family: SourceHanSansSC-regular;
  //   .content-left,
  .content-right {
    height: 100%;
    box-sizing: border-box;
    a {
      text-decoration: none;
      color: #000;
    }

    .search {
      // margin-left: 60px;
      .searchForm {
        width: 100%;
        .item {
          width: 120px;
        }
        .item-btn {
          margin-left: 30px;
        }
      }
    }
    .pagination {
      position: relative;
      bottom: 0;
    }
  }
.pagination .el-pagination {
  text-align: center;
}
  .content-left {
    padding-right: $content-middle;
  }
}
.nav-panel-sp{
  margin-top: 30px;
}
.no-data{
  text-align: center;
  padding: 100px 0;
}
.pr-item-flex{
    display:flex;
    flex-wrap:wrap;
  }
.font-weight-bold{
  font-weight: bold;
}
</style>
